import { render, staticRenderFns } from "./FranqueadoRevisao.vue?vue&type=template&id=68a38dca&scoped=true"
import script from "./FranqueadoRevisao.vue?vue&type=script&lang=js"
export * from "./FranqueadoRevisao.vue?vue&type=script&lang=js"
import style0 from "./FranqueadoRevisao.vue?vue&type=style&index=0&id=68a38dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a38dca",
  null
  
)

export default component.exports